import React from 'react';
import { useDispatch } from 'react-redux';

import DateRangePickerComponent from '@components/filterComponents/DateRangePickerComponent';

import { objForDateRange, objForPublishDate } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const DateRangeFilter = ({ rangeType = '' }) => {
	const dispatch = useDispatch();

	const onChangeDateRange = async (name, type, paramName1, paramName2, value1, value2) => {
		let dateRange = {
			name: 'dateRange',
			type: 'dateRange',
			key: value1 + ',' + value2,
			value: value1 + ' - ' + value2,
			identifier:
				rangeType === 'publishDate' ? 'collectionFilterPublishDateRange' : 'collectionFilterDateRange'
		};
		dispatch(storeItemInGlobalFilter(dateRange));
	};

	const onGetItem = () => {
		const item = rangeType === 'publishDate' ? { ...objForPublishDate } : { ...objForDateRange };
		return item;
	};

	return <DateRangePickerComponent rangeType={rangeType} item={onGetItem()} onChange={onChangeDateRange} />;
};

export default DateRangeFilter;
